//Types
import { Node, ParentNode, EntryNode, Navigation } from 'types/toc'
import { DownloadNode, DownloadChildNode, DownloadParentNode } from 'types/download'

function flattenNode(node: Node): Node[] {
  let nodes: Node[] = [node]

  if (node.type !== 'parent') {
    return nodes
  }

  const parent = node as ParentNode

  if (!parent.children || !parent.children.length) {
    return nodes
  }

  return nodes.concat(...parent.children.map(flattenNode))
}

export function flatten(toc: Node[]): Node[] {
  const nodes = toc.map(flattenNode)

  return ([] as Node[]).concat(...nodes)
}

export function flattenDocsets(toc: Node[]): string[] {
  return flatten(toc)
    .filter(node => {
      return node.type === 'entry'
    }).map( entryNode => {
      let en = entryNode as EntryNode
      return en.docset
    }) 
}

export function flattenEntries(toc: Node[]): EntryNode[] {
  return flatten(toc)
    .filter(node => {
      if (node.type !== 'entry' && node.type !== 'parent') {
        return false
      }

      if (node.type !== 'parent') {
        return true
      }

      const parent = node as ParentNode

      return parent.docset && parent.file
    }) as EntryNode[]
}

export function siblings(flattened: EntryNode[], docset: string | undefined, file: string): Navigation {
  const index = flattened.findIndex(node => node.docset === docset && node.file === file)

  if (index === -1) {
    return {}
  }

  const prev = flattened[index - 1] as EntryNode
  const next = flattened[index + 1] as EntryNode

  return {
    prev,
    next
  }
}

export function ancestry(toc: Node[], current: EntryNode): ParentNode[] {
  return []
}

export function selectAll(toc: DownloadNode[]): void {
  toc.forEach( node => {
    if (node.type === 'include') {
      let curr = node as DownloadChildNode
      curr.isSelected = !(curr.isSecure && curr.isLocked)
    } else if (node.type === 'parent') {
      let curr = node as DownloadParentNode
      if (curr.children && curr.children.length > 0) {
        selectAll(curr.children)
      }
    }
  })
}

export function unselectAll(toc: DownloadNode[]): void {
  toc.forEach( node => {
    if (node.type === 'include') {
      let curr = node as DownloadChildNode
      curr.isSelected = false
    } else if (node.type === 'parent') {
      let curr = node as DownloadParentNode
      if (curr.children && curr.children.length > 0) {
        unselectAll(curr.children)
      }
    }
  })
}